import React, { useState } from 'react'
import { Contact } from '../../models/conversations';
import { UtilityService } from '../../services/UtilityService';
import { Popover } from '@mui/material';
import { UserService } from '../../services/UserService';
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';

interface Props {
    numbers: any[];
    classes?: any
}

const GroupContactList = (props: Props) => {
    const Contacts: Contact[] = useSelector(selector.contacts)

    const [open, setOpen] = useState<Element | null>(null)
    const openPopup = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setOpen(e.currentTarget)
    }
    const closePopup = (e) => {
        e.stopPropagation();
        setOpen(null)

    }

    const getContact = (number) => {
        let contact = Contacts.find(contact => contact.PhoneNumber === number && contact.Name)
        return UserService.getUserPhoneNumber() === number ? "You" : !!contact ? UtilityService.trimMessage(contact.Name, 12) : UtilityService.maskPhoneNumberOnLength(number)
    }

    return (
        <>
            {
                props.numbers?.map((number, index) => (
                    <div className='d-flex' key={index}>
                        {
                            index + 1 > (props.numbers.length === 3 ? 3 : 2) ? null : <span className={`${index + 1 === 1 ? "" : "ml-1"} d-flex align-center justify-center ${props.classes ? props.classes : "h5-regular"}`} tabIndex={index + 1}>{getContact(number)}{index === 2 ? "" : ","}</span>
                        }
                    </div>
                ))
            }
            {
                ((props.numbers?.length - 2) > 1) &&
                <button className="ml-2 br-5 w-3 h-3 d-flex align-center justify-center more-button bg-color-rich-text-active" style={{ borderRadius: "50%" }} onMouseEnter={openPopup} onMouseLeave={closePopup}>+{props.numbers?.length - 2}
                </button>
            }
            {Boolean(open) &&
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={closePopup}
                    style={{ pointerEvents: 'none' }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    {
                        <div className=' w-v-13'>{props.numbers.map((number, index) => {
                            if (index + 1 > 2) {
                                return <div className='py-1 pl-2 h4-regular grid-row'>{getContact(number)}</div>
                            }
                        })}
                        </div>
                    }
                </Popover>
            }
        </>
    )
}

export default GroupContactList;